import { Component, OnInit } from '@angular/core';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { TableParams } from 'src/app/components/grid/TableParams';
import { ITableParams } from 'src/app/components/grid/ITableParams';
import { IExam, IScheduleCandidate } from 'src/app/interface/dto';
import { CandidateService } from 'src/app/services/candidate-service.service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-schedule-candidate',
  templateUrl: './schedule-candidate.component.html',
  styleUrls: ['./schedule-candidate.component.scss']
})
export class ScheduleCandidateComponent implements OnInit {

  exam: IExam = examDefault;

  schedule: IScheduleCandidate = {
    examinationID: 0,
    examNo: '',
    status: '',
    additionalMinutes: 0,
    score: 0,
    attempt: 0,
    startDate: null,
    endDate: null,
    randomiseVenues: false,
    notifyCandidatesByEmail: false,
    gapPerBatch: 0,
    capacityPerSlot: 0
  }
  tableParams: ITableParams;
  candidateList: any[];
  constructor(private popoverRef: PopoverRef<ScheduleCandidateComponent>,
    private examService: ExamService, private snackBar: SnackbarService, private candidateService: CandidateService) { }

  async ngOnInit() {
    if (this.examService.selectedExams?.length === 1) {
      this.exam = this.examService.selectedExams[0];
      this.schedule.examinationID = this.exam.id;
    }
    // this.candidateList = await this.candidateService.getCandidates(new TableParams(this.tableParams)) as any[];

  }

  close() {
    this.popoverRef.close();
  }

  async scheduleCandidate() {
    if (this.schedule.capacityPerSlot == 0) {
      this.snackBar.warning("Capacity is required to schedule");
      return;
    }
    if (this.schedule.examNo == '') {
      this.snackBar.warning("ExamNo is required to schedule");
      return;
    }
    await this.examService.candidateSchedule(this.schedule).then((candidate) => {
      this.snackBar.success("Candidate Scheduled")
      this.close();
    });
  }

}
